import styled from "@emotion/styled";
import { T, body, mono } from "./theme";

const shellBorder = (props) => (props.invalid ? T.danger : props.focused ? T.pine : T.lineStrong);

const shellShadow = (props) =>
  props.focused ? `0 0 0 3px ${props.invalid ? T.dangerSoft : T.pineSoft}` : "none";

export const StyledLabel = styled.label`
  display: block;
  font-family: ${body};
  font-size: 18px;
  font-weight: 600;
  color: ${T.ink};
  margin-bottom: 8px;
`;

export const StyledErrorText = styled.p`
  font-family: ${body};
  font-size: 12px;
  color: ${T.danger};
  margin: 8px 0 0;
`;

export const InputShell = styled.div`
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 16px;
  border-radius: 10px;
  background: ${T.surface};
  border: 1px solid ${shellBorder};
  box-shadow: ${shellShadow};
  transition: border-color 0.15s, box-shadow 0.15s;
`;

export const SelectShell = styled(InputShell)`
  position: relative;
  padding: 0;
`;

export const Affix = styled.span`
  color: ${T.inkFaint};
  font-size: ${(props) => (props.size === "small" ? 14 : 18)}px;
  ${(props) => (props.position === "left" ? "margin-right: 8px;" : "margin-left: 8px;")}
`;

export const StyledInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 18px;
  color: ${T.ink};
  font-family: ${(props) => (props.numeric ? mono : body)};
  font-variant-numeric: ${(props) => (props.numeric ? "tabular-nums" : "normal")};
`;

export const StyledSelect = styled.select`
  width: 100%;
  height: 100%;
  appearance: none;
  -webkit-appearance: none;
  border: none;
  outline: none;
  background: transparent;
  padding: 0 40px 0 16px;
  font-size: 18px;
  color: ${(props) => (props.hasValue ? T.ink : T.inkFaint)};
  font-family: ${body};
  cursor: pointer;
`;

export const SelectChevron = styled.svg`
  position: absolute;
  right: 16px;
  top: 17px;
  pointer-events: none;
`;

export const StyledBtn = styled.button`
  ${(props) =>
    props.variant === "primary"
      ? `background: ${T.pine}; color: #fff; border: 1px solid ${T.pine};`
      : `background: transparent; color: ${T.ink}; border: 1px solid ${T.lineStrong};`}
  width: ${(props) => (props.full ? "100%" : "auto")};
  height: 50px;
  padding: 0 24px;
  border-radius: 10px;
  font-family: ${body};
  font-size: 15px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  opacity: ${(props) => (props.disabled ? 0.55 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: opacity 0.15s;
`;

export const FullPageCenter = styled.div`
  background: ${T.paper};
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => props.tint && `color: ${T.pine};`}
`;

export const DangerBanner = styled.div`
  text-align: center;
  padding: 14px 16px;
  border-radius: 10px;
  background: ${T.dangerSoft};
  color: ${T.danger};
  font-size: 14px;
  font-weight: 600;
`;
